import { useCallback, useEffect, useState } from "react";
import {
  useSubscriptionContext,
} from "./SubscriptionProvider";
import { fetchSubscriptionStatus } from "../NewResume/paymentAccess";

export default function useSubscriptionStatus() {
  const context = useSubscriptionContext();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const payments = [];

  const refresh = useCallback(async (options = {}) => {
    const silent = Boolean(options?.silent);
    if (!silent) {
      setLoading(true);
    }

    try {
      const nextSubscription = await fetchSubscriptionStatus();
      setSubscription(nextSubscription);
      return nextSubscription;
    } catch (error) {
      setSubscription(null);
      return null;
    } finally {
      if (!silent) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    if (context) {
      return undefined;
    }

    refresh({ silent: true });
  }, [context, refresh]);

  if (context) {
    return context;
  }

  return {
    subscription,
    payments,
    active: Boolean(subscription?.active),
    expired: subscription?.status === "expired",
    loading,
    refresh,
    refreshSubscription: refresh,
    refreshPayments: async () => payments,
    refreshAll: async () => ({ subscription, payments }),
    waitForActiveSubscription: async ({ initialSubscription = null } = {}) =>
      initialSubscription || subscription,
    syncSubscription: setSubscription,
  };
}
